export default __webpack_public_path__ + "c18e7720a7bc6bae1c3badae22f2c8d8.png";